export default __webpack_public_path__ + "/dist/images/join-elysei.63e0fb219b146e9589e0050deb6b441f.svg";